<template>
  <ul>
    <li v-for="(log, index) in logs" :key="index">
      <v-chip :color="log.severity" text-color="white" small>{{log.result}}</v-chip>
      <span>{{log.description}}</span>
    </li>
    <slot />
  </ul>
</template>

<script>
export default {
  name: "EvaluateLogs",
  props: ["logs"]
};
</script>